(function () {
  'use strict';
  var sources = window.ecoflowHomeScriptSources;
  if (!sources || !window.ecoflowIsHomePage) return;

  var loads = {};
  var bundlePromise;
  var bundleTimer;
  var core = ['jquery', 'delegate', 'vendor', 'promotion', 'diy-cart-accessory-remove',
    'emarsys-tracker', 'swiper', 'theme', 'aiod-cart-bridge', 'cart-dpux-email-subscribe', 'alpine'];

  function isReady(name) {
    if (name === 'jquery') return !!window.jQuery;
    if (name === 'swiper') return !!window.Swiper;
    if (name === 'alpine') return !!window.Alpine;
    return false;
  }

  function loadScript(name) {
    if (loads[name]) return loads[name];
    if (isReady(name)) return Promise.resolve();
    if (!sources[name]) return Promise.reject(new Error('Unknown home dependency: ' + name));

    loads[name] = new Promise(function (resolve, reject) {
      var src = sources[name];
      var script = Array.prototype.find.call(document.scripts, function (item) {
        return item.src === new URL(src, location.href).href;
      });
      if (script && script.dataset.ecoflowLoadState === 'loaded') {
        resolve();
        return;
      }
      if (script && script.dataset.ecoflowLoadState === 'error') {
        script.remove();
        script = null;
      }
      var existing = !!script;
      script = script || document.createElement('script');
      script.addEventListener('load', function () {
        script.dataset.ecoflowLoadState = 'loaded';
        resolve();
      }, { once: true });
      script.addEventListener('error', function () {
        script.dataset.ecoflowLoadState = 'error';
        reject(new Error('Home dependency failed: ' + name));
      }, { once: true });
      if (!existing) {
        script.src = src;
        script.async = false;
        script.dataset.ecoflowHomeDeferred = name;
        document.head.appendChild(script);
      }
    }).catch(function (error) {
      delete loads[name];
      throw error;
    });
    return loads[name];
  }

  window.ecoflowLoadHomeDependencies = function (names) {
    return names.reduce(function (pending, name) {
      return pending.then(function () { return loadScript(name); });
    }, Promise.resolve());
  };

  window.ecoflowHomeFullBundleLoaded = false;
  window.ecoflowLoadHomeDeferredBundle = function (reason) {
    if (bundlePromise) return bundlePromise;
    clearTimeout(bundleTimer);
    bundlePromise = new Promise(function (resolve) {
      requestAnimationFrame(function () { requestAnimationFrame(resolve); });
    }).then(function () {
      return window.ecoflowLoadHomeDependencies(core);
    }).then(function () {
      window.ecoflowHomeFullBundleLoaded = true;
      window.dispatchEvent(new CustomEvent('ecoflow:home-full-bundle-loaded', {
        detail: { reason: reason || 'requested' }
      }));
      if ('requestIdleCallback' in window) requestIdleCallback(loadCountryPopups, { timeout: 8000 });
      else setTimeout(loadCountryPopups, 1000);
    }).catch(function (error) {
      bundlePromise = null;
      window.dispatchEvent(new CustomEvent('ecoflow:home-bundle-error', { detail: error }));
      throw error;
    });
    return bundlePromise;
  };

  function requestBundle(reason) {
    window.ecoflowLoadHomeDeferredBundle(reason).catch(function (error) {
      console.warn('[theme]', error.message);
    });
  }

  window.ecoflowObserveSection = function (root, init) {
    if (root.ecoflowDisposeObservation) return root.ecoflowDisposeObservation;
    var observer;
    var cleanup;
    var started = false;
    var disposed = false;
    var owner = root.closest('.shopify-section') || root;

    function run() {
      if (started || disposed) return;
      started = true;
      Promise.resolve().then(function () {
        if (!disposed) return init();
      }).then(function (dispose) {
        cleanup = dispose;
        if (observer) observer.disconnect();
        if (disposed && typeof cleanup === 'function') cleanup();
        if (!disposed) root.dataset.ecoflowInitialized = 'true';
      }).catch(function (error) {
        started = false;
        console.warn('[theme] section initialization failed', error);
      });
    }

    function unload(event) {
      if (event.target !== owner && !event.target.contains(root)) return;
      disposed = true;
      if (observer) observer.disconnect();
      root.removeEventListener('pointerdown', run);
      root.removeEventListener('focusin', run);
      document.removeEventListener('shopify:section:unload', unload);
      delete root.ecoflowDisposeObservation;
      if (typeof cleanup === 'function') cleanup();
    }

    root.addEventListener('pointerdown', run, { passive: true });
    root.addEventListener('focusin', run);
    document.addEventListener('shopify:section:unload', unload);
    if (!('IntersectionObserver' in window) || (window.Shopify && Shopify.designMode)) {
      run();
    } else {
      observer = new IntersectionObserver(function (entries) {
        if (entries.some(function (entry) { return entry.isIntersecting; })) run();
      }, { rootMargin: '600px 0px' });
      observer.observe(root);
    }
    root.ecoflowDisposeObservation = function () { unload({ target: owner }); };
    return root.ecoflowDisposeObservation;
  };

  document.addEventListener('pointerdown', function (event) {
    if (!event.target.closest('button, input, select, [role="button"], [data-open-password-free-login-popup]')) return;
    if (event.target.closest('[data-home-hover-card], [data-compare-trigger]')) return;
    requestBundle('control-intent');
  }, { passive: true });
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Tab' || event.key === 'Enter' || event.key === ' ') requestBundle('keyboard');
  });
  bundleTimer = setTimeout(function () { requestBundle('idle-fallback'); }, 12000);

  function loadCountryPopups() {
    ['ukraine-popup', 'ip-detect-popup'].forEach(function (name) {
      var selector = name === 'ukraine-popup' ? 'ukraine-popup' : 'ip-detect-popup';
      if (document.querySelector(selector)) loadScript(name).catch(function (error) {
        console.warn('[theme]', error.message);
      });
    });
  }
})();
